// BASE
import React from 'react';

import type { a2aTransfersTypes } from 'app-components/flux/a2aTransfers';
import { a2aTransfersUtils } from 'app-components/flux/a2aTransfers';

// CUSTOM COMPONENTS
import Chip, { ChipVariantEnum } from 'components/Chips/Chip';

interface ChipProps {
  id: string;
  status?: a2aTransfersTypes.TransferStatus | undefined;
}

export function TransferChip(props: ChipProps) {
  const { id, status } = props;
  const a2aEnums = a2aTransfersUtils.A2A_TRANSFER_ENUMS;

  if (status === a2aEnums.COMPLETED) {
    return (
      <Chip id={id} variant={ChipVariantEnum.SUCCESS}>
        Completed
      </Chip>
    );
  }
  if (status === a2aEnums.IN_PROGRESS || status === a2aEnums.SUBMITTED) {
    return (
      <Chip id={id} variant={ChipVariantEnum.ACTIVE}>
        Processing
      </Chip>
    );
  }
  if (status === a2aEnums.SCHEDULED) {
    return (
      <Chip id={id} variant={ChipVariantEnum.PENDING}>
        Scheduled
      </Chip>
    );
  }

  if (status === a2aEnums.CANCELLED) {
    return (
      <Chip id={id} variant={ChipVariantEnum.INACTIVE}>
        Cancelled
      </Chip>
    );
  }
  if (status === a2aEnums.FAILED || status === a2aEnums.REJECTED) {
    return (
      <Chip id={id} variant={ChipVariantEnum.ERROR}>
        Failed
      </Chip>
    );
  }
  return (
    <Chip id={id} variant={ChipVariantEnum.INACTIVE}>
      Error
    </Chip>
  );
}

TransferChip.displayName = 'TransferChip';

export default TransferChip;
